import React from 'react';
import TrainingCompletedModal from '../../TrainingCompletedModal/TrainingCompletedModal';
import { NOTIFICATION_TEMPLATES, renderNotificationTemplate } from '../notificationTemplates';

interface GenericNotificationProps {
    open: boolean;
    onClose: () => void;
    notificationType: string;
    notificationData: any;
    customTemplate?: any;
}

const GenericNotification: React.FC<GenericNotificationProps> = ({
    open,
    onClose,
    notificationType,
    notificationData,
    customTemplate,
}) => {
    const template = customTemplate || NOTIFICATION_TEMPLATES[notificationType] || NOTIFICATION_TEMPLATES['custom'];

    const handleHighlightClick = () => {
        if (notificationData?.customData?.onClickHighlight) {
            notificationData.customData.onClickHighlight();
        }
        onClose();
    };

    const renderedTemplate = renderNotificationTemplate(template, notificationData, handleHighlightClick);

    const handleButtonClick = () => {
        if (notificationData?.customData?.onButtonClick) {
            notificationData.customData.onButtonClick();
        }
        onClose();
    };

    const handleButtonClickWithCheckbox = (isCheckboxChecked: boolean) => {
        if (notificationData?.customData?.onButtonClickWithCheckbox) {
            notificationData.customData.onButtonClickWithCheckbox(isCheckboxChecked);
        } else {
            handleButtonClick();
        }
        onClose();
    };

    if (!open) return null;

    const modalConfig = notificationData?.modalConfig || {};

    
    return (
        <TrainingCompletedModal
            open={open}
            onClose={handleButtonClick}
            onButtonClickWithCheckbox={modalConfig.showCheckbox ? handleButtonClickWithCheckbox : undefined}
            showCheckbox={modalConfig.showCheckbox || false}
            checkboxLabel={modalConfig.checkboxLabel || 'Não mostrar esta notificação novamente'}
            checkboxChecked={modalConfig.checkboxChecked || false}
            onCheckboxChange={modalConfig.onCheckboxChange}
            {...renderedTemplate}
        />
    );
};

export default GenericNotification;
